<template>
  <div
    class="sb-group-button"
    :class="hasSpaces && 'sb-group-button--has-spaces'"
    v-bind="$attrs"
    role="group"
  >
    <VNodes :vnodes="activeSlots()" />
  </div>
</template>

<script setup lang="ts">
import VNodes from '../../utils/VNodes'

import type {
  AvailableButtonTypes,
  AvailableButtonVariants,
} from '../Button/lib'
import type { AvailableSizes } from '../../utils'

type Props = {
  variant?: AvailableButtonVariants
  size?: AvailableSizes
  type?: AvailableButtonTypes
  hasSpaces?: boolean
  isClear?: boolean
}

const props = defineProps<Props>()

const slots = defineSlots<{
  default(): any
}>()

const activeSlots = () => {
  const children: any = slots.default ? slots.default() : []
  return children
    .filter((b: any) => b.__v_isVNode)
    .map((button: any) => {
      button.props = {
        ...button.props,
        variant: props.variant,
        size: props.size,
        type: props.type,
        isClear: props.isClear,
      }
      return button
    })
}
</script>
